<template>
  <div id="donut-chart" style="position: relative" class="pb-1">
    <!-- <div class="total">AED 1000</div> -->
    <apex-chart 
      height="250"
      type="donut"
      :options="options"
      :series="series"
      :labels="labels"
    />
    <div class="mx-3 my-2 d-flex align-items-center justify-content-center form-check form-switch">
      <span>
        Invoice Count
      </span>
      <b-check
        v-if="toggleable"
        v-model="checked"
        :id="`toggle-${type}`"
        tabindex="-1"
        class="form-check-input ml-2"
        switch
      />
      <span>
        {{currency}} Amount
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "donut-chart",
  props: ["series1", "series2", "labels", "toggleable", "currency", "type"],
  data() {
    return {
      series: null,
      options: null,
      checked: false,
      options1: {
        legend: {
          show: true,
        },
        colors: ["#a5a5a5", "#FEFBB1", "#e44a4a", "#EBF5FE", "#c7fadd"],
        labels: this.labels,
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            expandOnClick: false,
            offsetX: 0,
            offsetY: 0,
            customScale: 1,
            dataLabels: {
                offset: 0,
                minAngleToShowLabel: 10
            }, 
            donut: {
              size: '60%',
              background: 'transparent',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: "#a5a5a5",
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: '#a5a5a5',
                  formatter: function (val) {
                    return val;
                  }
                },
                total: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: '#a5a5a5',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  }
                }
              }
            },      
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, opts.w.globals.series[opts.seriesIndex]];
          },
          style: {
              fontSize: '10px',
              fontWeight: 'normal',
              colors: ["#000"]
          },
          dropShadow: {
            enabled: false,
          }
        },
        tooltip: {
          enabled: false,
        }
      },
      options2: {
        legend: {
          show: true,
        },
        colors: ["#a5a5a5", "#FEFBB1", "#e44a4a", "#EBF5FE", "#c7fadd"],
        labels: this.labels,
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            expandOnClick: false,
            offsetX: 0,
            offsetY: 0,
            customScale: 1,
            dataLabels: {
                offset: 0,
                minAngleToShowLabel: 10
            }, 
            donut: {
              size: '60%',
              background: 'transparent',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: "#a5a5a5",
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: '#a5a5a5',
                  formatter: function (val) {
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }
                },
                total: {
                  show: true,
                  fontSize: '16px',
                  fontWeight: 'normal',
                  color: '#a5a5a5',
                   formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }
                }
              }
            },      
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name];
          },
          style: {
              fontSize: '10px',
              fontWeight: 'normal',
              colors: ["#000"]
          },
          dropShadow: {
            enabled: false,
          }
        },
        tooltip: {
          enabled: false,
        }
      },
    };
  },
  created() {
    this.series = this.series1;
    this.options = this.options1;
  },
  methods: {
    refreshData(){
      if (this.checked){
        this.series = this.series2;
        this.options = this.options2;
      }
      else{
        this.series = this.series1;
        this.options = this.options1;
      }
    }
  },
  watch:{
    checked(){
      this.refreshData();
    },
    series1(){
      this.refreshData();
    }
  },
};
</script>

<style scoped lang="scss">
  @import "./DonutChart.scss";
</style>
